/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface CreateNewAccountApiParameter extends ApiParameter {
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    companyName: string;
    typeOfBusiness: string;
    businessAddress: string;
    apartmentNo: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    comments: string;
}

const createNewAccountUrl = "api/mon/accounts/requestAccount";

export function createNewCustomerAccount(parameter: CreateNewAccountApiParameter) {
    return post(`${createNewAccountUrl}`, parameter);
}
